import { jsxs, jsx } from "react/jsx-runtime";
import { useState } from "react";
import FlashFocusModal from "./FlashFocusModal.js";
import { invokeFnAsync } from "../../utils/invokeFn.js";
import { nextTick } from "../../utils/nextTick.js";
import { useWindowSize } from "../useWindowSize/useWindowSize.js";
import { FocusModalContext } from "./FocusModalContext.js";
import "../../components/atoms/buttons/FlashButton/FlashButton.js";
import "../../index-e71f83b5.js";
import "../../_commonjsHelpers-0c53d963.js";
import "../../components/constants.js";
import "../../sass/sass.js";
import "../../components/atoms/info/FlashBadge/FlashBadge.js";
import "../../utils-65a8d69b.js";
import "../../components/atoms/info/FlashSpinner/FlashSpinner.js";
import "../../components/atoms/buttons/FlashButtonGeneric.js";
import "../../index-5e4e4f4b.js";
import "../../axios-5f69b112.js";
import "../../Button-dadda608.js";
import "../useInsights/useInsights.js";
import "../../utils/noOp.js";
import "../useLogger/constants.js";
import "../useLogger/useLogger.js";
import "../useLogger/LoggerContext.js";
import "../useLogger/types.js";
import "../useInsights/InsightsContext.js";
import "../useInsights/useInsightsImpression.js";
import "../../index-2d889c01.js";
import "../useInsights/utils.js";
import "../../components/atoms/buttons/FlashButton/constants.js";
import "../../components/atoms/popups/FlashPopover/FlashPopover.js";
import "../../TooltipPopoverWrapper-857e7584.js";
import "react-dom";
import "../../Popper-b45e70f5.js";
import "../../Manager-52cb3832.js";
import "../../Fade-5a502c0e.js";
import "../../Transition-a28a969d.js";
import "../useOutsideClickHandler/useOutsideClickHandler.js";
import "../../components/atoms/popups/FlashPopover/useFlashPopover.js";
import "../../i18n/index.js";
import "../../i18n/translations/en.js";
import "../../i18n/translations/es.js";
import "../../i18nInstance-89725fcb.js";
import "../../I18nextProvider-16dc4551.js";
import "../../useTranslation-cf39c293.js";
import "../useWindowSize/WindowSizeContext.js";
import "../../isObject-ec23ace2.js";
import "../../isSymbol-c6f5cd95.js";
function FocusModalContextProvider(props) {
  const { modals = [], targetZIndex = 9999 } = props, { windowIsMobile } = useWindowSize(), [unviewedCount, setUnviewedCount] = useState(0), [registeredModals, setRegisteredModals] = useState(
    // By default, all modals are initially hidden based on `hasBeenViewed: true`
    modals.map((m) => ({ ...m, node: null, hasBeenViewed: m.hasBeenViewed ?? !0 }))
  ), [movingToNext, setMovingToNext] = useState(!1), currentModal = windowIsMobile ? null : registeredModals.find((m) => !!m.node && !m.hasBeenViewed) || null;
  async function dismiss() {
    currentModal && (setRegisteredModals((prev) => prev.map((m) => ({ ...m, hasBeenViewed: !0 }))), await invokeFnAsync(currentModal.onDismiss, [modals.map((m) => m.uniqueId)]));
  }
  async function goToNext() {
    currentModal && (setMovingToNext(!0), setRegisteredModals(
      (prev) => prev.map((m) => m.uniqueId !== currentModal.uniqueId ? m : { ...m, hasBeenViewed: !0 })
    ), nextTick(() => {
      setMovingToNext(!1);
    }), await invokeFnAsync(currentModal.onNext, [currentModal.uniqueId]));
  }
  function nextCount() {
    if (!currentModal)
      return 0;
    const currentIndex = registeredModals.findIndex((m) => m.elementId === currentModal.elementId);
    return registeredModals.length - (currentIndex + 1);
  }
  const hasNext = nextCount() > 0, progressText = unviewedCount > 1 ? `${unviewedCount - nextCount()}/${unviewedCount}` : "";
  return /* @__PURE__ */ jsxs(
    FocusModalContext.Provider,
    {
      value: { registeredModals, setRegisteredModals, currentModal, targetZIndex, setUnviewedCount },
      children: [
        currentModal && /* @__PURE__ */ jsx(
          FlashFocusModal,
          {
            hasNext,
            movingToNext,
            targetZIndex,
            targetId: currentModal.elementId,
            targetNode: currentModal.node,
            progressText,
            onNext: goToNext,
            onDismiss: dismiss,
            ...currentModal.props
          }
        ),
        props.children
      ]
    }
  );
}
export {
  FocusModalContextProvider
};
//# sourceMappingURL=FocusModalContextProvider.js.map
